import React from 'react'
import { cn } from 'lib/utils'
import { Select as ShadcnSelect } from 'components/ui/select'
import { Label } from 'components/ui/label'

export default function SelectType({
	name,
	label,
	value,
	onChange,
	options,
	error = null,
	disabled = false,
	className,
	...other
}) {
	return (
		<div className={cn('tw-form-control w-full', className)}>
			{label && (
				<Label htmlFor={name} className="mb-1.5">
					{label}
				</Label>
			)}
			<ShadcnSelect
				name={name}
				value={value || ''}
				onChange={onChange}
				disabled={disabled}
				className={cn(error && 'border-destructive focus-visible:ring-destructive')}
				{...other}
			>
				<option value="" disabled></option>
				{options.map((item, index) => (
					<option key={index} value={item.selectValue}>
						{item.selectLabel || item.selectValue}
					</option>
				))}
			</ShadcnSelect>
			{error && <p className="mt-1 text-xs text-destructive">{error}</p>}
		</div>
	)
}
